import { ButtonColor, ButtonSize, ButtonVariant, Rounded } from '.'

export const BUTTON_CLASSES: Record<string, string> = {
  btn: 'font-medium flex items-center justify-center gap-2 cursor-pointer',
  'btn-disabled': 'cursor-not-allowed opacity-40 bg-slate-500 border-slate-500 !ring-0',
  'btn-filled': 'text-slate-50',
  'btn-empty': '!ring-0 bg-transparent',
  'btn-outlined': 'border opacity-80 hover:opacity-100',
  'btn-outlined-red':
    'bg-primarybg bg-opacity-20 border border-redborder text-high-emphesis hover:bg-opacity-40',
  'btn-outlined-gradient':
    'border border-gradient-r-gradientcustom-primarybg border-transparent opacity-80 hover:opacity-100',
  'btn-outlined-gradient-animated':
    'inline-block hover:animate-border group-hover:animate-border duration-500 ease-in-out bg-gradient-to-r from-gradientborderone via-gradientbordertwo to-gradientborderthree bg-[length:200%_200%] p-[1px] transition  focus:outline-none',
  'btn-outlined-gradient-animated-pre':
    'inline-block animate-border hover:animate-none group-hover:animate-none duration-500 ease-in-out bg-gradient-to-r from-gradientborderone via-gradientbordertwo to-gradientborderthree bg-[length:200%_200%] p-[1px] transition focus:outline-none',
  'btn-outlined-gray':
    'bg-primarybg bg-opacity-20 border border-grayoutline text-primary hover:bg-opacity-40',
  'btn-outlined-green':
    'bg-primarybg bg-opacity-20 border border-green-500 text-primary hover:bg-opacity-40',
  'btn-filled-red': 'bg-redbutton bg-opacity-80  text-high-emphesis hover:bg-opacity-100',
  'btn-filled-gradient':
    'transition duration-1000 ease-in-out text-primary  opacity-70 hover:opacity-100',
  'btn-filled-gradient-animated':
    'transition duration-1000 ease-in-out text-primary  bg-[length:200%_200%]  bg-gradient-to-tr from-gradientborderone via-gradientbordertwo to-gradientborderthree  overflow-hidden  opacity-70 hover:opacity-100',
  'btn-filled-gray': 'ring-transparent text-gray-600 bg-gray-300 text-primary ',
  'btn-filled-green': 'bg-green-500 bg-opacity-80 text-high-emphesis hover:bg-opacity-100',
  'btn-none': 'p-0 text-base',
  'btn-xs': 'px-2 h-[28px] text-xs',
  'btn-sm': 'px-3 h-[36px] text-sm font-semibold',
  'btn-nobase': 'p-0',
  'btn-default': 'px-3 h-[44px] text-sm font-semibold',
  'btn-md': 'px-4 h-[52px] rounded-2xl text-base font-semibold',
  'btn-lg': 'px-6 h-[60px] rounded-2xl text-base font-semibold',
  'btn-xl': 'px-12 py-8 text-base',
  'btn-empty-red': 'bg-transparent bg-opacity-80 hover:bg-opacity-100',
  'btn-empty-gray': 'bg-transparent bg-opacity-80 hover:bg-opacity-100',
  'btn-empty-green': 'bg-transparent bg-opacity-80 hover:bg-opacity-100',
  'btn-empty-gradient': 'bg-transparent bg-opacity-80 hover:bg-opacity-100',
  'btn-link-default':
    'text-primary hover:text-high-emphesis focus:text-high-emphesis whitespace-nowrap focus:ring-0',
  'btn-link-red':
    'text-primary hover:text-high-emphesis focus:text-high-emphesis whitespace-nowrap focus:ring-0',
  'btn-link-gray':
    'text-primary hover:text-high-emphesis focus:text-high-emphesis whitespace-nowrap focus:ring-0',
  'btn-link-green':
    'text-greenbutton text-opacity-80 hover:text-opacity-100 focus:text-opacity-100 whitespace-nowrap focus:ring-0',
  'btn-link-gradient':
    'bg-gradient-to-r from-gradientborderone via-gradientbordertwo to-gradientborderthree bg-clip-text text-transparent hover:bg-opacity-100 focus:bg-opacity-100 whitespace-nowrap focus:ring-0',
}

export const BUTTON_STYLES: Record<ButtonVariant, Record<ButtonColor, string>> = {
  outlined: {
    default: 'btn-outlined-default',
    red: 'btn-outlined-red',
    gray: 'btn-outlined-gray',
    green: 'btn-outlined-green',
    gradient: 'btn-outlined-gradient',
    gradientanimated: 'btn-outlined-gradient-animated',
    gradientanimatedpre: 'btn-outlined-gradient-animated-pre',
  },
  filled: {
    default: 'btn-filled-default',
    red: 'btn-filled-red',
    gray: 'btn-filled-gray',
    green: 'btn-filled-green',
    gradient: 'btn-filled-gradient',
    gradientanimated: 'btn-filled-gradient-animated',
    gradientanimatedpre: 'btn-filled-gradient-animated',
  },
  empty: {
    default: 'btn-empty-default',
    red: 'btn-empty-red',
    gray: 'btn-empty-gray',
    green: 'btn-empty-green',
    gradient: 'btn-empty-gradient',
    gradientanimated: 'btn-empty-gradient',
    gradientanimatedpre: 'btn-empty-gradient',
  },
  link: {
    default: 'btn-link-default',
    red: 'btn-link-red',
    gray: 'btn-link-gray',
    green: 'btn-link-green',
    gradient: 'btn-link-gradient',
    gradientanimated: 'btn-link-gradient',
    gradientanimatedpre: 'btn-link-gradient',
  },
}

export const BUTTON_STYLES_VARIANT: Record<ButtonVariant, string> = {
  outlined: 'btn-outlined',
  filled: 'btn-filled',
  empty: 'btn-empty',
  link: 'btn-link',
}

export const BUTTON_SIZES: Record<ButtonSize, string> = {
  none: 'btn-none',
  xs: 'btn-xs',
  sm: 'btn-sm',
  md: 'btn-md',
  nobase: 'btn-nobase',
  default: 'btn-default',
  lg: 'btn-lg',
  xl: 'btn-xl',
}

export const ROUNDED: Record<Rounded, string> = {
  rounded: 'rounded',
  'rounded-lg': 'rounded-lg',
  'rounded-xl': 'rounded-xl',
  none: 'none',
}
